import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, makeStyles } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";

const COLORS = [
  "#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76",
  "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3",
  "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3",
  "#D4C4FB", "#4D4D4D", "#999999", "#FFFFFF", "#F44E3B",
  "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA",
  "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080",
  "#CCCCCC", "#D33115", "#E27300", "#FCC400", "#B0BC00",
  "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF",
  "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00",
  "#808900", "#194D33", "#0C797D", "#0062B1", "#653294",
  "#AB149E", "#1E9855",
];

const CONSIG_GREEN = "#1E9855";

const isLight = (hex) => {
  const h = hex.replace("#", "");
  if (h.length < 6) return false;
  const r = parseInt(h.substr(0, 2), 16);
  const g = parseInt(h.substr(2, 2), 16);
  const b = parseInt(h.substr(4, 2), 16);
  return 0.299 * r + 0.587 * g + 0.114 * b > 165;
};

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 14,
    border: `1px solid ${theme.palette.divider}`,
  },
  title: {
    padding: "16px 20px 6px",
    fontWeight: 600,
    fontSize: "1rem",
    color: theme.palette.text.primary,
  },
  content: {
    padding: "6px 20px 20px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(10, 1fr)",
    gap: 9,
  },
  swatch: {
    width: 26,
    height: 26,
    borderRadius: "50%",
    cursor: "pointer",
    border: `2px solid ${
      theme.palette.type === "dark" ? "rgba(255,255,255,0.16)" : "rgba(0,0,0,0.10)"
    }`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "transform .12s ease, box-shadow .12s ease",
    "&:hover": {
      transform: "scale(1.18)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.35)",
    },
  },
  check: {
    fontSize: 16,
  },
}));

const ColorPicker = ({ onChange, currentColor, handleClose, open }) => {
  const classes = useStyles();
  const [selected, setSelected] = useState(currentColor);

  useEffect(() => {
    setSelected(currentColor);
  }, [currentColor, open]);

  const pick = (hex) => {
    setSelected(hex);
    if (onChange) onChange(hex);
    handleClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth="xs"
      classes={{ paper: classes.paper }}
    >
      <div className={classes.title}>Escolher cor</div>
      <DialogContent className={classes.content}>
        <div className={classes.grid}>
          {COLORS.map((c) => {
            const isSel =
              selected && selected.toLowerCase() === c.toLowerCase();
            return (
              <div
                key={c}
                className={classes.swatch}
                title={c}
                onClick={() => pick(c)}
                style={{
                  backgroundColor: c,
                  boxShadow: isSel ? `0 0 0 2px ${CONSIG_GREEN}` : undefined,
                }}
              >
                {isSel && (
                  <CheckIcon
                    className={classes.check}
                    style={{ color: isLight(c) ? "#000" : "#fff" }}
                  />
                )}
              </div>
            );
          })}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ColorPicker;
